import { DecisionCode } from '../types';

export const decisionCodeMapping = {
  [DecisionCode.Required]: 'Notification / Prior Authorization is required for this service',
  [DecisionCode.NotRequired]:
    'Notification /Prior Authorization is not required for this service. However, to get a decision ID, please click on Submit case.',
  [DecisionCode.Conditional]: 'Notification / Prior Authorization may be required for this service',
  [DecisionCode.Blocked]: 'This code requires a Genetic / Molecular Testing Prior Authorization',
};
